import * as types from './actionTypes';
import {api} from './api';

export function updateUserAuth(user) {
  return { type: types.AUTH__UPDATE_USER, user };
}

export function setLegacyUserAuth(username) {
  return { type: types.AUTH__SET_LEGACY_USER, username };
}


export function logInUser(user) {
    return api({
        types: [types.AUTH__AUTHENTICATE_USER_REQUEST, types.AUTH__AUTHENTICATE_USER_SUCCESS, types.AUTH__AUTHENTICATE_USER_FAILURE],
        uri: '/api/account/login',
        shouldCallAPI: () => true,
        sendJwtBearer: false,
        config: {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin', 
            body: JSON.stringify( user )
        },
        payload: user
    });
}

export function logOutUser() {
    return { type: types.LOGOUT__USER_SUCCESS  };
}

export function forgotPassword(email) {
    return api({
        types: [types.AUTH__FORGOT_PASSWORD_REQUEST, types.AUTH__FORGOT_PASSWORD_SUCCESS, types.AUTH__FORGOT_PASSWORD_FAILURE],
        uri: '/api/account/forgotpassword',
        shouldCallAPI: () => true,
        sendJwtBearer: false,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( { email } )
        },
        payload: { email }
    });
}

export function resetPassword(body) {
    return api({
        types: [types.AUTH__RESET_PASSWORD_REQUEST, types.AUTH__RESET_PASSWORD_SUCCESS, types.AUTH__RESET_PASSWORD_FAILURE],
        uri: '/api/account/resetpassword',
        sendJwtBearer: false,
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: body 
    });
}

export function changeLegacyUser(username) {
    return api({
        types: [types.AUTH__CHANGE_LEGACY_USER_REQUEST, types.AUTH__CHANGE_LEGACY_USER_SUCCESS, types.AUTH__CHANGE_LEGACY_USER_FAILURE],
        uri: '/api/account/legacyuser',        
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( {username} )
        },
        payload: { username }
    });
}